// extracted by mini-css-extract-plugin
module.exports = {"Switch":"ToogleButton_Switch__2UnuR"};